import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// eslint-disable-next-line max-len
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { CoreModule } from '@core/core.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { FormatPipeModule } from 'lingo2-ngx-date-fns';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';
import { UserServiceCard2Component } from './user-service-card-2.component';

@NgModule({
  declarations: [UserServiceCard2Component],
  imports: [
    CommonModule,
    CoreModule,
    TranslateModule,
    RouterModule,
    ModalModule,
    MobileModalModule,
    PipesModule,
    AlertModule,
    IconComponent,
    OnUiCardMenuModule,
    OnUiCoverModule,
    OnUiButtonModule,
    PaymentCheckoutWizardModule,
    BookmarkComponent,
    SubscribeComponent,
    RatingComponent,
    FormatPipeModule,
    AuthorInfoComponent,
  ],
  exports: [UserServiceCard2Component],
})
export class UserServiceCard2Module {}
